// extracted by mini-css-extract-plugin
export default {"waypointModal":"WaypointModal_waypointModal__+YKYR","map":"WaypointModal_map__JPswr"};